import { useSearchModule } from './useSearchModule';
export const useTranslation = (phrase) => {
    var _a;
    const searchModule = useSearchModule();
    return (_a = searchModule.translate(phrase || '')) !== null && _a !== void 0 ? _a : (phrase || '');
};
//# sourceMappingURL=useTranslation.js.map